<template>
  <v-container>
    <h1>Consulta de Inventario</h1>
    <p>
      Esta sección es para consultar el inventario actual. Dicho inventario se
      actualiza mediante los movimientos realizados. Es decir: al registrar un
      movimiento de <strong>entrada</strong> de 10 quesos, ahora habrá 10 quesos
      en el inventario. Y lo mismo ocurre en el sentido inverso. Al registrar un
      movimiento de <strong>salida</strong> de 3 quesos, quedarán 7 quesos en el
      inventario. <br /><br />
      Una vez que un lote llegue a 0 dejará de aparecer en el inventario.
    </p>
  </v-container>
</template>

<script>
export default {
  name: "DocsInventory",

  data: () => ({}),
};
</script>
